import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ensureProtocolInWebsiteUrl } from '../../../../utils/helpers';
import {
  formatAzerbaijanPhone,
  phoneWithInternationalCode
} from '../../../../utils/helpers/common';
import { Modal } from '../../../ui/Modal';
import {
  ContactEmail,
  ContactsModalContainer,
  ContactWebsite,
  headerStyles,
  LinksContainer,
  modalStyles,
  PhoneLink
} from './styled';
import { BackButtonIconEnum } from '../../../ui/PageHeader/types';

interface ContactsModalProps {
  isOpen: boolean;
  onClose: () => void;
  phonesShown: string[];
  contactEmail?: string | null;
  website?: string | null;
}

export const ContactsModal: React.FC<ContactsModalProps> = memo(
  ({ phonesShown, isOpen, onClose, contactEmail, website }) => {
    const { t } = useTranslation();

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        modalId="residence-contacts-modal"
        cypress="residence-contacts-modal"
        modalStyles={modalStyles}
        title={t('residences.numbers')}
        headerIcon={BackButtonIconEnum.Close}
        closeButtonAlign="right"
        headerStyles={headerStyles}
      >
        <ContactsModalContainer>
          <LinksContainer>
            {phonesShown?.map((phone, i) => {
              const phoneInternationalCode = phoneWithInternationalCode(phone);

              return (
                <PhoneLink
                  key={i}
                  href={`tel:${phoneInternationalCode}`}
                  data-stat="residence-phones"
                >
                  {formatAzerbaijanPhone(phoneInternationalCode)}
                </PhoneLink>
              );
            })}
          </LinksContainer>
          {contactEmail && (
            <ContactEmail
              href={`mailto:${contactEmail}`}
              data-stat="residence-email"
            >
              {contactEmail}
            </ContactEmail>
          )}
          {website && (
            <ContactWebsite
              href={ensureProtocolInWebsiteUrl(website)}
              data-stat="residence-website"
            >
              {website}
            </ContactWebsite>
          )}
        </ContactsModalContainer>
      </Modal>
    );
  }
);

ContactsModal.displayName = `ContactsModal`;
